import { createContext } from 'react'

import { type V1ListUserLocationsResponse } from '@src/network/src/__gen__/local-map'

export type UserLocationType = V1ListUserLocationsResponse | null

const UserLocationContext = createContext<UserLocationType>(null as any)

export default UserLocationContext
